import React, { useState, useEffect } from 'react'
import { useDispatch } from 'react-redux'
import { useParams, useHistory } from 'react-router-dom'
import {
  Row,
  Panel,
  IconButton,
  Icon,
  Modal,
  Button,
  Col,
  ControlLabel,
  RadioGroup,
  Radio,
  Message,
  SelectPicker,
  Input,
  Checkbox,
  Uploader,
} from 'rsuite'
import AttachFilesMakeContract from './AttachFilesMakeContract'
import AttachFilesMakeContractView from './AttachFilesMakeContractView'
import AttachFilesGranteeContract from './AttachFilesGranteeContract'
import scrollToComponent from 'react-scroll-to-component'
import { useForm, Controller } from 'react-hook-form'
import EditButton from '../../components/buttons/editButton/EditButton'
import ViewButton from '../../components/buttons/viewButton/ViewButton'
import {
  getDownload,
  getAttachments,
  saveAttachments,
  updateAttachments,
  deleteAttachments,
} from '../../redux/actions/attachments'
import { startLoading, doneLoading } from '../../utils/loading'
import { getSchemaSidebar } from '../../redux/actions/sidebar'
import PdfRenderWidgets from '../pdfWidgets/PdfRenderWidgets'
import { isRequired, isValidators, isRequiredFiled } from '../../utils/ValidatorUtils'
import {
  saveAttachmentGrantee,
  getAttachmentGrantee,
  updateMakeContractChangeWithdrawPerson,
  getMakeContractChangeWithdrawPerson,
  getDownloadAttachmentGrantee,
  getContractPdf,
  getDownloadContractPdf,
  getDownloadContractPdfRealtime,
  getDownloadProposalPdfRealtime,
  getAddAttachmentsContractForm,
  saveAddAttachmentsContractAndBankAccount,
  downloadOpenBankAccountFile,
  getBankAccount,
  downloadFileByPath,
  deleteAttachmentChangeWithdrawPerson,
} from '../../redux/actions/contract'
import ConfirmWidget from '../../widgets/confirm/ConfirmWidget'
import pathname from '../../constants/pathname'
import classNames from 'classnames'
import ErrorMessage from '../../components/message/errorMessage/ErrorMessage'
import InputForm from '../../components/forms/input/InputForm'
import CenterAddBankAccountForm from '../../widgets/contractCenterAddBankAccount/CenterAddBankAccountForm'
import { getAllAttachments } from '../../redux/actions/attachments'
import AttachFilesDocWidget from '../../widgets/attachfiles/AttachFilesDocWidget'
import { API_ROOT } from '../../config/config'
import COIValidateWidget from '../coi/COIValidateWidget'
import OverlayLoader from '../../components/OverlayLoader/OverlayLoader'
import { isEmpty } from 'lodash-es'
import AppContext from '../../context/AppContext'
import ApproverList from '../../components/modal/ApproverListModal/ApproverList'
import SaveButton from '../../components/buttons/saveButton/SaveButton'
import CancelApprovalList from '../../components/modal/ApproverListModal/CancelApprovalList'
import FetchNewApprover from '../../components/modal/ApproverListModal/FetchNewApprover'
import InputRadioForm from '../../components/forms/input/InputRadioForm'
import { DEFAULT_ERR_MSG } from '../../constants/msgText'

export default function MakeContractChangeWithdrawPersonPanel(props) {
  const {
    showCommandButton,
    schemaFile: _schemaFile,
    isCoworker,
    isCoordinator,
    isApprover,
    isContractCenter,
    cancelButton,
    checkButton,
    fetchButton,
    onSuccess = () => {},
    id = null,
  } = props
  const { register, handleSubmit, errors, control, setValue, clearErrors, getValues } = useForm()
  const [isLoading, setIsLoading] = useState(false)
  const formSchema = props.schema
  const [showConfirm, setShowConfirm] = useState(false)
  const [isMakeContractError, setIsMakeContractError] = useState(false)
  const [signatoryList, setSignatoryList] = useState([])
  const [request, setRequest] = useState()

  const [withdrawAuthorizedRequest, setWithdrawAuthorizedRequest] = useState(1)
  const [sendToGranteeVal, setSendToGranteeVal] = useState(false)
  const [showConfirmDelete, setShowConfirmDelete] = useState(false)
  const [deleteObject, setDeleteObject] = useState(null)
  const [isContractCenterChangePerson, setIsContractCenterChangePerson] = useState(false)

  const [schemaFile, setSchemaFile] = useState(_schemaFile)

  const { theme } = React.useContext(AppContext)

  const dispatch = useDispatch()
  //const projectId = useSelector((state) => state.getParameter?.projectId)
  const projectId = sessionStorage.getItem('projectId')
  const history = useHistory()

  useEffect(() => {
    let arr = props?.schema?.withdrawAuthorized?.values || []
    let isGanteeCompany = props?.schema?.withdrawAuthorized?.granteeCompany
    console.log('arr', arr)
    if (arr.length > 0) {
      let newList = sortByMainPersonFirst(arr)

      if (isGanteeCompany) {
        switch (newList.length) {
          case 1:
            newList.push(
              { honorific: '', firstName: '', lastName: '' },
              { honorific: '', firstName: '', lastName: '' }
            )
            break
          case 2:
            newList.push({ honorific: '', firstName: '', lastName: '' })
            break
          default:
            break
        }
      }
      console.log('newList', newList)
      setSignatoryList(newList)

      newList.forEach((item, index) => {
        setValue(formSchema?.withdrawAuthorized?.honorific?.name + index, item.honorific)
        setValue(formSchema?.withdrawAuthorized?.firstName?.name + index, item.firstName)
        setValue(formSchema?.withdrawAuthorized?.lastName?.name + index, item.lastName)
      })
    } else {
      let initialList = [{ honorific: '', firstName: '', lastName: '' }]
      if (isGanteeCompany) {
        initialList.push(
          { honorific: '', firstName: '', lastName: '' },
          { honorific: '', firstName: '', lastName: '' }
        )
      }

      setSignatoryList(initialList)
    }

    if (isGanteeCompany) {
      setWithdrawAuthorizedRequest(3) //set number of request person e.g. 3 = 3 person (need to set newList and initialList)
    }
  }, [props?.schema?.withdrawAuthorized?.values])

  const sortByMainPersonFirst = (list) => {
    let newList = [...list]
    list.forEach((item, index) => {
      if (item.isMainPerson) {
        newList.splice(index, 1)
        newList.unshift(item)
      }
    })
    return newList
  }

  const handleUpdateMakeContract = async (request) => {
    startLoading()
    setIsLoading(true)
    setIsMakeContractError(false)
    try {
      let response = await updateMakeContractChangeWithdrawPerson(request, projectId)

      if (response.success) {
        //success! jump to new page
        setIsMakeContractError(false)
        setIsLoading(false)
        doneLoading()
        return history.push(`${pathname.proposal.overview.overviewCoworker}`)
      } else {
        setIsMakeContractError(true)
      }
      setShowConfirm(false)
    } catch (e) {
      console.log('e', e.response)
      setIsMakeContractError(true)
      setShowConfirm(false)
    }
    setShowConfirm(false)
    setIsLoading(false)
    doneLoading()
  }

  const handleDeleteFile = async (deleteObject) => {
    startLoading()
    setIsLoading(true)
    setIsMakeContractError(false)
    try {
      let status = await deleteAttachmentChangeWithdrawPerson(request, deleteObject.fileId)
      if (status === 200) {
        let response = await getMakeContractChangeWithdrawPerson(projectId)
        setSchemaFile(response?.model?.forms?.refFile)
      }
    } catch (e) {
      console.log('e', e.response)
      notification.open('error', {
        title: e?.response?.data?.errors?.message || DEFAULT_ERR_MSG,
        duration: 5000,
      })
    }
    setShowConfirmDelete(false)
    setIsLoading(false)
    doneLoading()
  }

  const onDownload = async (fileObj) => {
    startLoading()
    try {
      var file = await downloadFileByPath(fileObj.filePath)
      // var file = []

      const url = window.URL.createObjectURL(new Blob([file], { type: file.type }))
      const link = document.createElement('a')
      link.href = url
      link.setAttribute('download', fileObj.label)
      document.body.appendChild(link)
      link.click()
    } catch (e) {
      console.log('download error', e)
    }
    doneLoading()
  }

  const onPreview = async (fileObj) => {
    startLoading()
    try {
      var file = await downloadFileByPath(fileObj.filePath)
      // var file = []

      const url = window.URL.createObjectURL(new Blob([file], { type: file.type }))
      const link = document.createElement('a')
      link.href = url
      link.target = '_blank'
      link.setAttribute('value', fileObj.label)
      document.body.appendChild(link)
      link.click()
    } catch (e) {
      console.log('preview error', e)
    }
    doneLoading()
  }

  const onDelete = (rowData) => {
    setShowConfirmDelete(true)
    setDeleteObject(rowData)
  }

  const onSubmit = (data) => {
    console.log('data', data)
    console.log('attachFiles => ', formSchema.attachmentGrantee.attachFiles)
    console.log('signatoryList', signatoryList)
    //console.log('formBankAccountSchema => ', formBankAccountSchema)

    let withdrawPerson = signatoryList.map((item, index) => {
      const honorificName = formSchema?.withdrawAuthorized?.honorific?.name + index
      const firstNameName = formSchema?.withdrawAuthorized?.firstName?.name + index
      const lastNameName = formSchema?.withdrawAuthorized?.lastName?.name + index

      return {
        ...item,
        honorific: data[honorificName] ?? item.honorific,
        firstName: data[firstNameName] ?? item.firstName,
        lastName: data[lastNameName] ?? item.lastName,
        isMainPerson: index === 0,
      }
    })

    let request = {
      projectVersionId: projectId,
      withdrawPerson: withdrawPerson,
    }

    const formData = new FormData()

    // formData.append('WithdrawPerson', schemas?.progressReportsId || null || '')
    withdrawPerson &&
      withdrawPerson?.forEach((element, index) => {
        //formData.append(`WithdrawPerson.no[${index}]`, element.no)
        formData.append(`WithdrawPerson[${index}].honorific`, element.honorific)
        formData.append(`WithdrawPerson[${index}].firstName`, element.firstName)
        formData.append(`WithdrawPerson[${index}].lastName`, element.lastName)
        formData.append(`WithdrawPerson[${index}].isMainPerson`, element.isMainPerson)
        // formData.append(`WithdrawPerson.isDeleted[${index}]`, element.isDeleted)
        // formData.append(`WithdrawPerson.disable[${index}]`, element.disable)
        // formData.append(`WithdrawPerson.email[${index}]`, element.email)
      })
    data.refFile &&
      data.refFile?.forEach((element) => {
        formData.append('Files', element.blobFile)
      })
    formData.append('Remark', data[formSchema?.remark?.name] || '')
    formData.append('IsSendToGrantee', sendToGranteeVal || false)
    formData.append('ApproveType', data[formSchema?.approveType?.name] || '')
    formData.append('Id', id || '')
    formData.append('IsContractCenterChangePerson', isContractCenterChangePerson || false)

    console.log('request', request)
    setRequest(formData)
    setShowConfirm(true)
  }

  const handleOnConfirm = () => {
    handleUpdateMakeContract(request)
  }

  const handlePlusMonth = () => {
    let arr = [...signatoryList]
    arr.push({ honorific: '', firstName: '', lastName: '' })
    setSignatoryList(arr)
  }

  const handleDeleteMonth = (index) => {
    let arr = [...signatoryList]
    // console.log('arr', arr, 'index', index)
    arr.splice(index, 1)
    setSignatoryList(arr)
  }

  const getHonorificLabel = (item) => {
    return (
      item.preName ||
      formSchema?.withdrawAuthorized?.honorific?.options?.find(
        (option) => option.value === item.honorific
      )?.label ||
      ''
    )
  }

  const getRefFileViewSchema = () => {
    const value = Array.isArray(schemaFile?.value)
      ? schemaFile.value
      : schemaFile?.value
        ? [schemaFile.value]
        : []

    var newValue = value.map((item) => {
      return {
        ...item,
        label: item.fileName || item.fileLabel,
      }
    })

    return { value: newValue }
  }

  const renderSignatory = signatoryList.map((item, index) => {
    return (
      <Row key={index}>
        <Col xs={24} sm={8} md={4} lg={4} style={{ marginTop: 35, width: 100 }}>
          {index == 0 ? 'ผู้ลงนามหลัก' : 'ผู้ลงนามร่วม'}
        </Col>
        <Col xs={24} sm={8} md={5} lg={5} style={{ marginTop: '10px' }}>
          <ControlLabel
            className={classNames(
              'style-text-lable',
              isRequired(formSchema?.withdrawAuthorized?.honorific?.validators) && 'required'
            )}
          >
            {formSchema?.withdrawAuthorized?.honorific?.label}
          </ControlLabel>
          <ErrorMessage error={errors[formSchema?.withdrawAuthorized?.honorific?.name + index]} />
          <Controller
            name={formSchema?.withdrawAuthorized?.honorific?.name + index}
            control={control}
            defaultValue={item.honorific}
            rules={isValidators(formSchema?.withdrawAuthorized?.honorific?.validators)}
            render={(props) => {
              return (
                <SelectPicker
                  data={formSchema?.withdrawAuthorized?.honorific?.options}
                  value={props.value}
                  style={{ width: '100%' }}
                  placeholder="เลือก"
                  disabled={item.disable}
                  onChange={(value) => {
                    props.onChange(value)
                  }}
                />
              )
            }}
          />
        </Col>
        <Col xs={24} sm={8} md={5} lg={5} style={{ marginTop: '10px' }}>
          <ControlLabel
            className={classNames(
              'style-text-lable',
              isRequired(formSchema?.withdrawAuthorized?.firstName?.validators) && 'required'
            )}
          >
            {formSchema?.withdrawAuthorized?.firstName?.label}
          </ControlLabel>
          <ErrorMessage error={errors[formSchema?.withdrawAuthorized?.firstName?.name + index]} />
          <Controller
            key={formSchema?.withdrawAuthorized?.firstName?.name + index}
            name={formSchema?.withdrawAuthorized?.firstName?.name + index}
            control={control}
            rules={isValidators(formSchema?.withdrawAuthorized?.firstName?.validators)}
            defaultValue={item.firstName}
            render={(props) => {
              return (
                <Input
                  name={formSchema?.withdrawAuthorized?.firstName?.name + index}
                  defaultValue={item.firstName}
                  value={props.value}
                  placeholder={formSchema?.withdrawAuthorized?.firstName?.label}
                  onChange={(e) => {
                    props.onChange(e)
                  }}
                  disabled={item.disable}
                />
              )
            }}
          />
        </Col>
        <Col xs={24} sm={8} md={5} lg={5} style={{ marginTop: '10px' }}>
          <ControlLabel
            className={classNames(
              'style-text-lable',
              isRequired(formSchema?.withdrawAuthorized?.lastName?.validators) && 'required'
            )}
          >
            {formSchema?.withdrawAuthorized?.lastName?.label}
          </ControlLabel>
          <ErrorMessage error={errors[formSchema?.withdrawAuthorized?.lastName?.name + index]} />
          <Controller
            key={formSchema?.withdrawAuthorized?.lastName?.name + index}
            name={formSchema?.withdrawAuthorized?.lastName?.name + index}
            control={control}
            rules={isValidators(formSchema?.withdrawAuthorized?.lastName?.validators)}
            defaultValue={item.lastName}
            render={(props) => {
              return (
                <Input
                  name={formSchema?.withdrawAuthorized?.lastName?.name + index}
                  defaultValue={item.lastName}
                  value={props.value}
                  placeholder={formSchema?.withdrawAuthorized?.lastName?.label}
                  onChange={(e) => {
                    props.onChange(e)
                  }}
                  disabled={item.disable}
                />
              )
            }}
          />
        </Col>
        {index >= withdrawAuthorizedRequest && (
          <Col xs={4} sm={4} md={3} lg={3} style={{ marginTop: 32, width: 50 }}>
            <IconButton
              appearance="ghost"
              className="rs-btn-ghost-cancel"
              icon={<Icon appearance="ghost" icon="trash" className="bt-gost-icon-radius-cancel" />}
              onClick={() => handleDeleteMonth(index)}
              style={{ marginLeft: 5 }}
            ></IconButton>
          </Col>
        )}

        {signatoryList.length - 1 === index && (
          <Col xs={4} sm={4} md={4} lg={4} style={{ marginTop: 32, width: 50 }}>
            <IconButton
              appearance="ghost"
              icon={<Icon appearance="ghost" icon="plus" className="bt-gost-icon-radius" />}
              onClick={() => handlePlusMonth()}
            >
              เพิ่มผู้ลงนามร่วม
            </IconButton>
          </Col>
        )}
      </Row>
    )
  })

  const renderSignatoryView = signatoryList
    .filter((item) => item.preName || item.honorific || item.firstName || item.lastName)
    .map((item, index) => {
      return (
        <Row key={index}>
          <Col xs={24} sm={24} md={24} lg={24} style={{ marginTop: 10 }}>
            {item.isMainPerson || index === 0 ? 'ผู้ลงนามหลัก : ' : 'ผู้ลงนามร่วม : '}
            {`${getHonorificLabel(item)} ${item.firstName || ''} ${item.lastName || ''}`.trim() ||
              'ไม่ระบุ'}
          </Col>
        </Row>
      )
    })

  return (
    <>
      {isLoading && <OverlayLoader />}

      <Panel header={formSchema.panelText} bordered collapsible defaultExpanded shaded>

      {schemaFile && schemaFile?.value?.length > 0 &&
        <>
          <span>{schemaFile.label}</span>
          <AttachFilesMakeContractView
            schema={getRefFileViewSchema()}
            enableDelete={isCoworker && !formSchema?.remark?.disabled}
            onDelete={onDelete}
            onDownload={onDownload}
            onPreview={onPreview}
            loading={isLoading}
          />
          </>
        }

        {schemaFile && (
          <>
            {showCommandButton ? (
              <Row>
                <Col xs={24} sm={24} md={24} lg={24} style={{ marginTop: '10px' }}>
                  <ControlLabel
                    className={classNames(isRequired(schemaFile.validators) && 'required')}
                  >
                    {schemaFile.label}
                  </ControlLabel>
                  <ErrorMessage error={errors.refFile} />
                  <Controller
                    name={schemaFile.name}
                    control={control}
                    // defaultValue={
                    //   !isEmpty(schemaFile.value) ? [schemaFile.value] : undefined
                    // }
                    rules={schemaFile.value.length == 0 && isValidators(schemaFile.validators)}
                    render={(props) => {
                      return (
                        <Uploader
                          draggable
                          autoUpload={false}
                          multiple={false}
                          fileList={props.value || []}
                          onChange={(fileList) => {
                            if (isEmpty(fileList)) {
                              props.onChange(undefined)
                            } else {
                              let files = []
                              files.push(fileList[fileList.length - 1])
                              props.onChange(files)
                            }
                          }}
                        >
                          <div>
                            <div
                              style={{ lineHeight: '50px' }}
                              className={classNames('uploader', `${theme[0]}-background`)}
                            >
                              <Icon size="4x" icon="upload2" />
                              <small className="uploder__text">
                                <p style={{ wordBreak: 'break-word' }}>
                                  คลิกหรือลากไฟล์มายังพื้นที่นี้เพื่ออัปโหลด
                                </p>
                              </small>
                            </div>
                          </div>
                        </Uploader>
                      )
                    }}
                  />
                </Col>
              </Row>
            ) : (
              <>
                {/* <span>{schemaFile.label}</span>
                <AttachFilesMakeContractView
                  schema={getRefFileViewSchema()}
                  onDownload={onDownload}
                  onPreview={onPreview}
                /> */}
              </>
            )}
          </>
        )}

        <br />

        {formSchema?.withdrawAuthorized && (
          <>
            <span className="required">{formSchema.withdrawAuthorized.header}</span>
            {showCommandButton && (
              <Message
                showIcon
                type="warning"
                description={
                  'ห้ามระบุเจ้าหน้าที่การเงินของโครงการเป็นผู้มีอำนาจสั่งจ่ายเงินจากบัญชีรับเงินสนับสนุนโครงการ'
                }
              />
            )}
            {showCommandButton && (
              <Message
                showIcon
                type="warning"
                description={
                  'กรุณาตรวจสอบ คำนำหน้า ชื่อ-นามสกุล ให้ถูกต้องตรงกับบัตรประจำตัวประชาชน'
                }
              />
            )}
            
            <Row>
              {signatoryList.length > 0 &&
                (showCommandButton || isContractCenterChangePerson ? renderSignatory : renderSignatoryView)}

              {showCommandButton && signatoryList.length === 0 && (
                <Col xs={24} sm={24} md={24} lg={24} style={{ marginTop: 34, width: 50 }}>
                  <IconButton
                    appearance="ghost"
                    icon={<Icon appearance="ghost" icon="plus" className="bt-gost-icon-radius" />}
                    onClick={() => handlePlusMonth()}
                  >
                    เพิ่มผู้ลงนามหลัก
                  </IconButton>
                </Col>
              )}
              {!showCommandButton && renderSignatoryView.length === 0 && (
                <Col xs={24} sm={24} md={24} lg={24} style={{ marginTop: 10 }}>
                  ไม่ระบุ
                </Col>
              )}
            </Row>
            <br />

            {isContractCenter && 
              <Checkbox
                checked={isContractCenterChangePerson}
                onChange={(value, checked) => {
                  if(!checked) {
                    props?.schema?.withdrawAuthorized?.values?.forEach((item, index) => {
                      setValue(formSchema?.withdrawAuthorized?.honorific?.name + index, item.honorific)
                      setValue(formSchema?.withdrawAuthorized?.firstName?.name + index, item.firstName)
                      setValue(formSchema?.withdrawAuthorized?.lastName?.name + index, item.lastName)
                    })
                  }
                  setIsContractCenterChangePerson(checked)
                }}
              >
                แก้ไขชื่อผู้ลงนามเปิดบัญชี และเบิกจ่าย
              </Checkbox>}
          </>
        )}

        {!isCoworker && formSchema.coworkerRemark && (
          <Message type="info" description={formSchema.coworkerRemark} />
        )}
        {!isCoordinator && formSchema.coordinatorRemark && (
          <Message type="info" description={formSchema.coordinatorRemark} />
        )}
        {!isApprover && formSchema.approvereRemark && (
          <Message type="info" description={formSchema.approvereRemark} />
        )}

        {isCoordinator && !formSchema?.remark.disabled && (
          <>
            <br />
            <Checkbox
              defaultChecked={sendToGranteeVal}
              onChange={(_, checked, e) => {
                console.log('checked ', checked)
                setSendToGranteeVal(checked)
              }}
            >
              {'ส่งกลับให้ผู้รับทุนแก้ไข'}
            </Checkbox>
          </>
        )}

        {isApprover && (
          <Row>
            {formSchema?.approveType && !formSchema?.remark.disabled && (
              <InputRadioForm
                schema={formSchema.approveType}
                register={register}
                Controller={Controller}
                control={control}
                errors={errors}
                setValue={setValue}
                clearErrors={clearErrors}
                disabled={formSchema?.remark.disabled}
                //onChange={onContractTypeChange}
              />
            )}
          </Row>
        )}

        {formSchema?.remark &&
          (!formSchema?.remark.disabled ? (
            <Row>
              <Col xs={24} sm={24} md={24} lg={24}>
                <InputForm
                  schema={formSchema.remark}
                  rows={4}
                  componentClass="textarea"
                  register={register}
                  Controller={Controller}
                  control={control}
                  errors={errors}
                  setValue={setValue}
                  clearErrors={clearErrors}
                />
              </Col>
            </Row>
          ) : (
            <p style={{ marginTop: 10 }}>
              <span>{formSchema.remark.label}</span>
              <br />
              &nbsp;&nbsp;&nbsp;&nbsp;{formSchema.remark.value || 'ไม่ระบุ'}
            </p>
          ))}

        {showCommandButton && <hr />}

        {isContractCenter && <hr />}

        {isMakeContractError && (
          <Message showIcon type="error" description={formSchema.buttonText + `ไม่สำเร็จ`} />
        )}

        {showCommandButton && (
          <IconButton
            appearance="ghost"
            icon={<Icon icon="send" className="bt-gost-icon-radius"></Icon>}
            onClick={handleSubmit(onSubmit)}
          >
            {formSchema.buttonText}
          </IconButton>
        )}

        {isCoordinator && !formSchema?.remark?.disabled && (
          <Row>
            {sendToGranteeVal ? (
              <IconButton
                appearance="ghost"
                icon={<Icon icon="send" className="bt-gost-icon-radius"></Icon>}
                disabled={!sendToGranteeVal}
                onClick={handleSubmit(onSubmit)}
              >
                {'ส่งกลับให้ผู้รับทุนแก้ไข'}
              </IconButton>
            ) : (
              <ApproverList
                approveType={13}
                projectversionId={projectId}
                style={{
                  marginRight: 10,
                  marginBottom: 10,
                }}
                buttontext={'ตรวจสอบสายอนุมัติและ' + formSchema.buttonText}
                isLoading={isLoading}
                fetchButton={(disabled) => (
                  <IconButton
                    style={{ marginBottom: 10 }}
                    appearance="ghost"
                    icon={<Icon icon="send" className="bt-gost-icon-radius"></Icon>}
                    onClick={handleSubmit(onSubmit)}
                  >
                    {sendToGranteeVal ? 'ส่งกลับให้ผู้รับทุนแก้ไข' : formSchema.buttonText}
                  </IconButton>
                )}
              />
            )}
          </Row>
        )}

        {isCoordinator && checkButton && (
          <ApproverList
            approveType={13}
            projectversionId={projectId}
            style={{ marginRight: 10 }}
            buttontext={checkButton}
            isLoading={isLoading}
            fetchButton={(disabled) =>
              fetchButton && (
                <FetchNewApprover
                  approveType={13}
                  projectversionId={projectId}
                  style={{ marginRight: 10, marginBottom: 10 }}
                  buttontext={fetchButton}
                  onSuccess={onSuccess}
                  disabled={disabled}
                />
              )
            }
            // contractModifyType={contractModifyType}
          />
        )}
        {isCoordinator && cancelButton && (
          <CancelApprovalList
            approveType={13}
            projectversionId={projectId}
            style={{ marginRight: 10 }}
            buttontext={cancelButton}
            onSuccess={onSuccess}
          />
        )}

        {(isApprover || isContractCenter) && !formSchema?.remark?.disabled && (
          <IconButton
            appearance="ghost"
            icon={<Icon icon="save" className="bt-gost-icon-radius"></Icon>}
            onClick={handleSubmit(onSubmit)}
          >
            {formSchema.buttonText}
          </IconButton>
        )}

        <ConfirmWidget
          title={`ยืนยันการ${
            sendToGranteeVal ? 'ส่งกลับให้ผู้รับทุนแก้ไข' : formSchema.buttonText
          }`}
          show={showConfirm}
          detail={`ท่านต้องการ${
            sendToGranteeVal ? 'ส่งกลับให้ผู้รับทุนแก้ไข' : formSchema.buttonText
          } ใช่หรือไม่ ?`}
          onCancle={() => setShowConfirm(false)}
          onConfirm={() => handleOnConfirm()}
        />

        <ConfirmWidget
          title={`ยืนยันการลบ`}
          show={showConfirmDelete}
          detail={`ท่านต้องการลบรายการนี้ใช่หรือไม่ ?`}
          onCancle={() => setShowConfirmDelete(false)}
          onConfirm={() => handleDeleteFile(deleteObject)}
        />
      </Panel>
    </>
  )
}
